import { render, staticRenderFns } from "./PreviousVersionIdFieldType.vue?vue&type=template&id=51590e58"
import script from "./PreviousVersionIdFieldType.vue?vue&type=script&lang=js"
export * from "./PreviousVersionIdFieldType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports